import React from "react";
import { Switch, Route } from "react-router-dom";

import CustomersPage from "./CustomersPage";
import CustomerPage from "./CustomerPage";

const Customers = () => (
  <Switch>
    <Route path="/finance/customers/:id">
      <CustomerPage />
    </Route>
    <Route path="/finance/customers">
      <CustomersPage />
    </Route>
  </Switch>
);

export default Customers;
